// Firebase Configuration for PlaySpaces
import { initializeApp } from "firebase/app";
import { 
  getAuth, 
  GoogleAuthProvider, 
  signInWithPopup, 
  signInWithPhoneNumber,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  RecaptchaVerifier,
  signOut,
  onAuthStateChanged
} from "firebase/auth";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

// Your web app's Firebase configuration from environment variables with fallbacks
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyC4kpyUC50Veqezz33-2yG_xbsZ2ccG8wQ",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "playspaces-auth.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "playspaces-auth",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "playspaces-auth.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "28202898080",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:28202898080:web:5cdf2cdb421a5fd7edafc5"
};

// Initialize Firebase
let app;
let auth;
let googleProvider;
let messaging = null;

try {
  app = initializeApp(firebaseConfig);
  auth = getAuth(app);
  googleProvider = new GoogleAuthProvider();
  
  // Initialize Firebase Cloud Messaging (only in supported browsers)
  try {
    if (typeof window !== 'undefined' && 'serviceWorker' in navigator && 'Notification' in window) {
      messaging = getMessaging(app);
    } else {
      console.log('[FCM] Browser does not support push notifications');
    }
  } catch (error) {
    console.log('[FCM] Messaging not supported in this browser:', error.message);
    messaging = null;
  }
} catch (error) {
  console.error('[Firebase] Initialization error:', error);
}

// VAPID Key for web push
// Get this from Firebase Console > Project Settings > Cloud Messaging > Web Push certificates
// Generate a key pair and copy the public key here
const VAPID_KEY = process.env.REACT_APP_FIREBASE_VAPID_KEY || 'YOUR_VAPID_KEY_FROM_FIREBASE_CONSOLE';

// Request notification permission and get FCM token
export async function requestNotificationPermission() {
  if (!messaging) {
    console.log('[FCM] Messaging not available');
    return null;
  }

  try {
    const permission = await Notification.requestPermission();
    
    if (permission === 'granted') {
      console.log('[FCM] Notification permission granted');
      
      // Wait for the service worker to be ready
      const registration = await navigator.serviceWorker.ready;
      
      // Get FCM token using the main service worker (which now includes FCM)
      const token = await getToken(messaging, { 
        vapidKey: VAPID_KEY,
        serviceWorkerRegistration: registration
      });
      
      console.log('[FCM] Token obtained:', token?.substring(0, 20) + '...');
      return token;
    } else {
      console.log('[FCM] Notification permission denied');
      return null;
    }
  } catch (error) {
    console.error('[FCM] Error getting token:', error);
    return null;
  }
}

// Listen for foreground messages
export function onForegroundMessage(callback) {
  if (!messaging) return () => {};
  
  return onMessage(messaging, (payload) => {
    console.log('[FCM] Foreground message received:', payload);
    callback(payload);
  });
}

// Export auth utilities
export { 
  auth, 
  googleProvider, 
  messaging,
  signInWithPopup, 
  signInWithPhoneNumber,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  RecaptchaVerifier,
  signOut,
  onAuthStateChanged
};
export default app;
